import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LOGO_URL } from "../lib/brand";
import { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const empty = {
  name: "", whatsapp: "", email: "", confirmEmail: "",
  city: "", country: "México", password: "", confirmPassword: "",
};

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(empty);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const validate = () => {
    if (form.email.trim().toLowerCase() !== form.confirmEmail.trim().toLowerCase())
      return "Los correos electrónicos no coinciden";
    if (form.password !== form.confirmPassword) return "Las contraseñas no coinciden";
    if (form.password.length < 6) return "La contraseña debe tener al menos 6 caracteres";
    return "";
  };

  const submit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (v) { setError(v); return; }
    setError("");
    setLoading(true);
    try {
      const user = await register(form);
      toast.success(`¡Cuenta creada! Bienvenido, ${user.name}`);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none focus:border-brand-forest";

  return (
    <div className="mx-auto flex max-w-xl flex-col px-6 py-14">
      <div className="mb-6 text-center">
        <img src={LOGO_URL} alt="VALORA" className="mx-auto h-14 w-auto object-contain" />
        <h1 className="mt-6 font-display text-2xl font-extrabold text-brand-navy">Crea tu cuenta</h1>
        <p className="mt-1 text-sm text-slate-500">Regístrate para acceder a las certificaciones VALORA</p>
      </div>

      <form onSubmit={submit} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        {error && <div className="mb-4 rounded-lg bg-rose-50 p-3 text-sm text-rose-600">{error}</div>}

        <div className="grid gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <label className="mb-1 block text-sm font-semibold text-slate-700">Nombre completo *</label>
            <input data-testid="register-name-input" required value={form.name} onChange={set("name")} className={field} />
          </div>
          <div>
            <label className="mb-1 block text-sm font-semibold text-slate-700">WhatsApp *</label>
            <input data-testid="register-whatsapp-input" required placeholder="+52 55 1234 5678" value={form.whatsapp} onChange={set("whatsapp")} className={field} />
          </div>
          <div>
            <label className="mb-1 block text-sm font-semibold text-slate-700">Ciudad *</label>
            <input data-testid="register-city-input" required value={form.city} onChange={set("city")} className={field} />
          </div>
          <div>
            <label className="mb-1 block text-sm font-semibold text-slate-700">Correo electrónico *</label>
            <input data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} className={field} />
          </div>
          <div>
            <label className="mb-1 block text-sm font-semibold text-slate-700">Confirmar correo *</label>
            <input data-testid="register-confirm-email-input" type="email" required value={form.confirmEmail} onChange={set("confirmEmail")} className={field} />
          </div>
          <div>
            <label className="mb-1 block text-sm font-semibold text-slate-700">País *</label>
            <input data-testid="register-country-input" required value={form.country} onChange={set("country")} className={field} />
          </div>
          <div className="hidden sm:block" />
          <div>
            <label className="mb-1 block text-sm font-semibold text-slate-700">Contraseña *</label>
            <input data-testid="register-password-input" type="password" required value={form.password} onChange={set("password")} className={field} />
          </div>
          <div>
            <label className="mb-1 block text-sm font-semibold text-slate-700">Confirmar contraseña *</label>
            <input data-testid="register-confirm-password-input" type="password" required value={form.confirmPassword} onChange={set("confirmPassword")} className={field} />
          </div>
        </div>

        <button
          data-testid="register-submit-button"
          disabled={loading}
          className="mt-6 w-full rounded-xl brand-navy py-3.5 text-sm font-bold text-white transition-transform hover:scale-[1.02] disabled:opacity-60"
        >
          {loading ? "Creando cuenta…" : "Crear mi cuenta"}
        </button>
      </form>

      <p className="mt-5 text-center text-sm text-slate-500">
        ¿Ya tienes cuenta?{" "}
        <Link to="/login" className="font-bold text-brand-forest">Inicia sesión</Link>
      </p>
    </div>
  );
}
